<template>
    <div class="upload-container">
        <div v-for="(item, index) in cdnUrl" :key="index" class="images">
            <el-image v-if="index < max" :src="item" :style="`width:${width}px;height:${height}px;`" fit="cover" />
            <div class="mask">
                <div class="actions">
                    <span title="预览" @click="preview(index)">
                        <i class="el-icon-zoom-in" />
                    </span>
                    <span title="下载" v-if="hasDown" @click="down(index)">
                        <i class="el-icon-download" />
                    </span>
                    <span v-if="ifEdit" title="移除" @click="remove(index)">
                        <i class="el-icon-delete" />
                    </span>
                    <span v-show="url.length > 1" title="左移" :class="{ disabled: index == 0 }" @click="move(index, 'left')">
                        <i class="el-icon-back" />
                    </span>
                    <span v-show="url.length > 1" title="右移" :class="{ disabled: index == url.length - 1 }" @click="move(index, 'right')">
                        <i class="el-icon-right" />
                    </span>
                </div>
            </div>
        </div>
        <el-upload
            v-if="ifEdit"
            ref="upload"
            v-loading="loading"
            v-show="url.length < max"
            :limit="limit"
            :show-file-list="false"
            :headers="headers"
            :action="action"
            :data="data"
            :name="name"
            :before-upload="beforeUpload"
            :on-progress="onProgress"
            :on-success="onSuccess"
            drag
            class="images-upload">
            <div class="image-slot" :style="`width:${width}px;height:${height}px;`">
                <i class="el-icon-plus" />
            </div>
            <div v-show="progress.percent" class="progress" :style="`width:${width}px;height:${height}px;`">
                <el-image :src="progress.preview" :style="`width:${width}px;height:${height}px;`" fit="fill" />
                <el-progress type="circle" :width="Math.min(width, height) * 0.8" :percentage="progress.percent" />
            </div>
        </el-upload>
        <div v-if="!notip && ifEdit" class="el-upload__tip">
            <div style="display: inline-block">
                <el-alert :title="`上传图片支持 ${ext.join(' / ')} 格式，图片数量不超过 ${max} 张`" type="info" show-icon :closable="true" />
                <!-- <el-alert :title="`上传图片支持 ${ ext.join(' / ') } 格式，单张图片大小不超过 ${ size }MB，建议图片尺寸为 ${width}*${height}，且图片数量不超过 ${ max } 张`" type="info" show-icon :closable="false" /> -->
            </div>
        </div>
        <el-image-viewer
            v-if="imageViewerVisible"
            :on-close="
                () => {
                    imageViewerVisible = false;
                }
            "
            :url-list="[dialogImageUrl]" />
    </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import store from "@/store/index";
import { queryHelpFileUrlMd5 } from "@/api/cdn";
import { resolve } from "tinymce/themes/silver/theme";
import { isArray } from "xe-utils";
import { Loading } from "element-ui";

export default {
    name: "ImagesUpload",
    components: {
        ElImageViewer,
    },
    computed: {
        store() {
            return store;
        },
    },
    props: {
        limit: {
            type: Number,
            required: false,
        },
        ifEdit: {
            typer: Boolean,
            default: true,
        },
        hasDown: {
            type: Boolean,
            default: false,
        },
        action: {
            type: String,
            default: "/api/common/fileServer/upload",
        },
        headers: {
            type: Object,
            default: () => {
                return {
                    Authorization: `Bearer ${store.state.user.token}`,
                };
            },
        },
        data: {
            type: Object,
            default: () => {},
        },
        name: {
            type: String,
            default: "file",
        },
        url: {
            type: Array,
            default: () => [],
        },
        max: {
            type: Number,
            default: 10,
        },
        size: {
            type: Number,
            default: 2,
        },
        width: {
            type: Number,
            default: 150,
        },
        height: {
            type: Number,
            default: 150,
        },
        placeholder: {
            type: String,
            default: "",
        },
        notip: {
            type: Boolean,
            default: false,
        },
        ext: {
            type: Array,
            default: () => ["jpg", "png", "gif", "bmp", "jpeg"],
        },
    },
    data() {
        return {
            hasFormat: false,
            cdnUrl: [],
            localUrl: [],
            loading: false,
            dialogImageUrl: "",
            imageViewerVisible: false,
            progress: {
                preview: "",
                percent: 0,
            },
        };
    },
    mounted() {
        this.localUrl = this.formatUrl(this.url);
        this.getCdnUrl();
    },
    watch: {
        url: {
            handler(newValue, oldValue) {
                // queryHelpFileUrlMd5({ codes: this.value }).then((res) => {
                //   console.log(res);
                // });
                if (!oldValue && newValue) {
                    this.localUrl = this.formatUrl(newValue);
                    this.getCdnUrl();
                }
            },
            immediate: true,
        },
    },
    methods: {
        down(index) {
            // window.open(this.cdnUrl[index])
            // console.log(this.cdnUrl[index])
            this.downImg(this.cdnUrl[index]);
        },
        downImg(url) {
            const xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.open("GET", url);
            xhr.send();

            xhr.onload = function () {
                const blob = new Blob([xhr.response], { type: "image/*" });
                const a = document.createElement("a");
                a.href = URL.createObjectURL(blob);
                a.download = url.replace(/.*\/(.*)\?.*/, "$1");
                a.click();
            };
        },
        getCdnUrl() {
            // return new Promise((resolve) => {
            //   queryHelpFileUrlMd5({ codes: this.formatUrl(this.localUrl) }).then((res) => {
            //     this.cdnUrl = res.map((item) => item.url);
            //     resolve();
            //   });
            // });

            return new Promise((resolve) => {
                if (Array.isArray(this.localUrl) && this.localUrl.length) {
                    queryHelpFileUrlMd5({ codes: this.formatUrl(this.localUrl) }).then((res) => {
                        this.cdnUrl = res.map((item) => item.url);
                        resolve();
                    });
                } else {
                    this.cdnUrl = [];
                    resolve();
                }
            });
        },
        formatUrl(list) {
            let myList = list.map((item) => {
                let arr = item.split("/");
                let url = arr[arr.length - 1];
                return url;
            });
            return myList;
        },
        getLink(src) {
            if (src.indexOf("//") == -1) {
                return "//res.jzyglxt.com/idi/" + src;
            }
            return src;
        },
        // 预览
        preview(index) {
            this.dialogImageUrl = this.cdnUrl[index];
            this.imageViewerVisible = true;
        },
        // 移除
        remove(index) {
            // 创建副本，不直接修改 props
            let url = [...this.url];
            url.splice(index, 1);

            this.localUrl = this.formatUrl(url);
            this.getCdnUrl().then(() => {
                this.$emit("update:url", this.localUrl);
            });
            
            // 清空 el-upload 内部的文件列表，否则达到 limit 后无法再上传
            this.$refs.upload && this.$refs.upload.clearFiles();
        },
        // 移动
        move(index, type) {
            // 创建副本，不直接修改 props
            let url = [...this.url];
            if (type == "left" && index != 0) {
                url[index] = url.splice(index - 1, 1, url[index])[0];
            }
            if (type == "right" && index != url.length - 1) {
                url[index] = url.splice(index + 1, 1, url[index])[0];
            }

            this.localUrl = this.formatUrl(url);
            this.getCdnUrl().then(() => {
                this.$emit("update:url", this.localUrl);
            });
        },
        beforeUpload(file) {
            const fileName = file.name.split(".");
            const fileExt = fileName[fileName.length - 1].toLowerCase();

            const isTypeOk = this.ext.indexOf(fileExt) >= 0;
            const isSizeOk = file.size / 1024 / 1024 < this.size;
            if (!isTypeOk && this.ext.length) {
                this.$message.error(`上传图片只支持 ${this.ext.join(" / ")} 格式！`);
            }
            if (!isSizeOk) {
                this.$message.error(`上传图片大小不能超过 ${this.size}MB！`);
            }
            if (isTypeOk && isSizeOk) {
                this.progress.preview = URL.createObjectURL(file);
            }
            if (isSizeOk && !this.ext.length) {
                this.progress.preview = URL.createObjectURL(file);
            }
            this.loading = true;
            return isTypeOk && isSizeOk;
        },
        onProgress(file) {
            this.progress.percent = ~~file.percent;
            if (this.progress.percent == 100) {
                this.progress.preview = "";
                this.progress.percent = 0;
            }
        },
        onSuccess(res) {
            this.loading = false;
            this.$emit("on-success", res);
            this.$emit("success", res);

            // 创建副本，不直接修改 props
            let url = [...this.url];
            url.push(res.data.url);
            this.localUrl = this.formatUrl(url);
            this.getCdnUrl().then(() => {
                this.$emit("update:url", this.localUrl);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.upload-container {
    line-height: initial;
}
.images {
    position: relative;
    display: inline-block;
    margin-right: 10px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    overflow: hidden;
    .el-image {
        display: block;
    }
    .mask {
        opacity: 0;
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        font-size: 24px;
        background-color: rgba(0, 0, 0, 0.5);
        transition: all 0.3s;
        .actions {
            width: 100px;
            height: 100px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            @include position-center(xy);
            span {
                width: 50%;
                text-align: center;
                color: #fff;
                cursor: pointer;
                transition: all 0.1s;
                &.disabled {
                    color: #999;
                    cursor: not-allowed;
                }
                &:hover:not(.disabled) {
                    transform: scale(1.5);
                }
            }
        }
    }
    &:hover .mask {
        opacity: 1;
    }
}
.images-upload {
    display: inline-block;
}
::v-deep .el-upload {
    .el-upload-dragger {
        width: auto;
        height: auto;
        &.is-dragover {
            border-width: 1px;
        }
        .image-slot {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            color: #909399;
            font-size: 30px;
            background-color: transparent;
        }
        .progress {
            position: absolute;
            top: 0;
            &::after {
                content: "";
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                background-color: rgba(0, 0, 0, 0.2);
            }
            .el-progress {
                z-index: 1;
                @include position-center(xy);
                .el-progress__text {
                    color: #fff;
                }
            }
        }
    }
}
</style>
